<!-- PAGE_TYPE: EDITOR -->
<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>{{ pageType }} Team Members</ion-title>
    <ion-buttons mode="ios" slot="end">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" tappable>
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="admin-modal-content" data-testid="add-team-member-content">
  <ion-list>
    <ion-item>
      <ion-input
        label="Search user (email recommended)"
        label-placement="stacked"
        [(ngModel)]="lookupQuery"
        placeholder="Enter user email or UID"
      ></ion-input>
      <ion-button slot="end" color="dark" [disabled]="isLookingUp" (click)="lookupUser()">
        {{ isLookingUp ? "Searching..." : "Find" }}
      </ion-button>
    </ion-item>

    @if (matchedUser) {
      <ion-item>
        <ion-textarea
          label="Matched User (confirm)"
          label-placement="stacked"
          [readonly]="true"
          [value]="matchedUserSummary"
        ></ion-textarea>
      </ion-item>

      @if (pageType === "Add" && alreadyTeamMember) {
        <ion-item>
          <ion-text color="danger">This user is already added as a team member.</ion-text>
        </ion-item>
      }
    }

    <ion-item>
      <ion-select label="Select User Role" label-placement="stacked" placeholder="Select any role" [(ngModel)]="userRole">
        @for (role of roles; track role) {
          <ion-select-option [value]="role">
            {{ role }}
            @if (isRoleElevated(role)) {
              ⚡
            }
          </ion-select-option>
        }
      </ion-select>
    </ion-item>

    <!-- Selected Role Badge Preview -->
    @if (userRole) {
      <ion-item lines="none" class="selected-role-preview">
        <ion-badge [color]="getRoleColor(userRole)">
          <ion-icon [name]="getRoleIcon(userRole)"></ion-icon>
          {{ userRole }}
          @if (isRoleElevated(userRole)) {
            <ion-icon name="shield-checkmark" title="Elevated Role (Dual-Control)"></ion-icon>
          }
        </ion-badge>
        @if (isRoleElevated(userRole)) {
          <ion-text color="warning">Requires dual-control approval</ion-text>
        }
      </ion-item>
    }

    <ion-item>
      <ion-textarea
        label="Description"
        label-placement="stacked"
        [(ngModel)]="description"
        placeholder="Type something here"
      ></ion-textarea>
    </ion-item>

    <ion-item>
      <ion-textarea
        label="Change reason"
        label-placement="stacked"
        [(ngModel)]="changeReason"
        placeholder="Required audit reason for this claims change"
      ></ion-textarea>
    </ion-item>
  </ion-list>
  <!-- Dynamic Roles Information (Phase 9: Access Control UI) -->
  <section class="roles-info-panel">
    <h6>Roles Information</h6>
    @for (role of allRoleDefinitions; track role.id) {
      <article class="role-info-card">
        <div class="role-info-heading">
          <ion-badge [color]="role.color">
            <ion-icon [name]="role.icon"></ion-icon>
            {{ role.displayName }}
            @if (role.requiresDualControl) {
              <ion-icon name="shield-checkmark" title="Dual-Control Required"></ion-icon>
            }
          </ion-badge>
          <span>Authority Level: {{ role.authority }}</span>
        </div>
        <p>
          {{ role.description }}
        </p>
        @if (role.requiresDualControl) {
          <small>Requires dual-control approval for sensitive actions</small>
        }
      </article>
    }
  </section>
</ion-content>

<ion-footer class="admin-modal-footer">
  <ion-toolbar color="light" mode="ios">
    <div class="ion-text-center">
      <ion-button
        shape="round"
        color="dark"
        [disabled]="!userRole || (pageType === 'Add' && (!matchedUser || alreadyTeamMember))"
        (click)="options()"
      >
        {{ pageType === "Edit" ? "Update" : pageType }} User
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
